import { render } from "./chat-detalhes.vue?vue&type=template&id=d5658cd2"
import script from "./chat-detalhes.vue?vue&type=script&lang=js"
export * from "./chat-detalhes.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__